/**
 * ============================================================================
 * Hotel Delivery - Frontend Logic (Phase 3 / Multilingual)
 * ----------------------------------------------------------------------------
 * Phase 2 までの機能に加えて、Phase 3 では5言語対応を追加：
 *   - en (英語、デフォルト)
 *   - ja (日本語)
 *   - zh-CN (中国語簡体字)
 *   - zh-TW (中国語繁体字)
 *   - ko (韓国語)
 *
 * 言語切替は Shopify の locale に追従。
 * Liquid の data-language 属性経由で受け取り、対応する翻訳を使用。
 *
 * 依存：なし（プレーンJS、外部ライブラリゼロ）
 * ============================================================================
 */

(function () {
  'use strict';

  // ==========================================================================
  // 翻訳辞書
  // ==========================================================================
  const TRANSLATIONS = {
    en: {
      search_unavailable: 'Search is temporarily unavailable. Please try again.',
      no_hotels:          'No hotels found. Try a different search term.',
      geo_unsupported:    'Geolocation is not supported by your browser.',
      locating:           'Locating...',
      location_found:     'Your location: {lat}, {lng}. Type your hotel name to search.',
      location_failed:    'Could not get your location. Please type your hotel name instead.',
      details_failed:     'Could not load hotel details. Please try again.',
      need_checkin:       'Please enter your check-in date.',
      need_checkout:      'Please enter your check-out date.',
      need_delivery:      'Please select your preferred delivery date.',
      checkout_after_in:  'Check-out must be after check-in.',
      delivery_before_co: 'Please pick a delivery date at least 1 day before your check-out — your gift may not be safely received on your departure day.',
      delivery_after_in:  'Delivery should be on or after your check-in date.',
      earliest_delivery:  'The earliest possible delivery is {date} given today and shipping time. Please pick that date or later.',
      ok_message:         "Gift arrives <strong>{date}</strong> — {days} day{s} before your check-out. We'll hand it to the front desk.",
      today_label:        'Today',
      arrives_label:      'Arrives',
      legend_stay:        'Your stay',
      legend_arrives:     'Gift arrives',
      select_hotel_first: 'Please select your hotel before checking out.',
      complete_schedule:  'Please complete your schedule before checking out.',
      arrival_in_days:    'arrives in about {days} day{s} from order',
      zone_main_island:   'Main Island',
      zone_hokkaido:      'Hokkaido & Tohoku North',
      zone_kyushu:        'Kyushu',
      zone_okinawa:       'Okinawa',
    },

    ja: {
      search_unavailable: '検索が一時的に利用できません。もう一度お試しください。',
      no_hotels:          '該当するホテルが見つかりませんでした。別のキーワードでお試しください。',
      geo_unsupported:    'お使いのブラウザは位置情報に対応していません。',
      locating:           '位置情報を取得中...',
      location_found:     '現在地: {lat}, {lng}。ホテル名を入力して検索してください。',
      location_failed:    '位置情報を取得できませんでした。ホテル名を直接入力してください。',
      details_failed:     'ホテル情報を取得できませんでした。もう一度お試しください。',
      need_checkin:       'チェックイン日をご入力ください。',
      need_checkout:      'チェックアウト日をご入力ください。',
      need_delivery:      '配送希望日をお選びください。',
      checkout_after_in:  'チェックアウトはチェックインより後の日付にしてください。',
      delivery_before_co: 'チェックアウトの1日以上前を配送日にお選びください。出発日当日の配送は確実な受け取りができない可能性があります。',
      delivery_after_in:  '配送日はチェックイン日以降にしてください。',
      earliest_delivery:  '本日の配送可能な最短日は {date} です。それ以降の日付をお選びください。',
      ok_message:         '<strong>{date}</strong> にお届け — チェックアウトの{days}日前です。フロントにお預けします。',
      today_label:        '本日',
      arrives_label:      '到着',
      legend_stay:        'ご滞在期間',
      legend_arrives:     '商品到着日',
      select_hotel_first: 'チェックアウトの前にホテルをお選びください。',
      complete_schedule:  'チェックアウトの前に日程をご入力ください。',
      arrival_in_days:    'ご注文から約{days}日でお届け',
      zone_main_island:   '本州中央部',
      zone_hokkaido:      '北海道・東北北部',
      zone_kyushu:        '九州',
      zone_okinawa:       '沖縄',
    },

    'zh-CN': {
      search_unavailable: '搜索暂时不可用，请稍后再试。',
      no_hotels:          '未找到酒店，请尝试其他关键词。',
      geo_unsupported:    '您的浏览器不支持定位功能。',
      locating:           '正在获取位置...',
      location_found:     '您的位置：{lat}, {lng}。请输入酒店名称进行搜索。',
      location_failed:    '无法获取您的位置，请直接输入酒店名称。',
      details_failed:     '无法加载酒店详情,请重试。',
      need_checkin:       '请输入入住日期。',
      need_checkout:      '请输入退房日期。',
      need_delivery:      '请选择您希望的送达日期。',
      checkout_after_in:  '退房日期必须晚于入住日期。',
      delivery_before_co: '请选择退房日前至少1天的送达日期 — 退房当天送达可能无法安全签收。',
      delivery_after_in:  '送达日期需在入住日期当天或之后。',
      earliest_delivery:  '从今天和发货时间计算,最早可送达日期为 {date}。请选择该日期或之后。',
      ok_message:         '礼物将于 <strong>{date}</strong> 送达 — 距您退房还有{days}天。我们将交至前台保管。',
      today_label:        '今天',
      arrives_label:      '送达',
      legend_stay:        '您的住宿期',
      legend_arrives:     '礼物送达',
      select_hotel_first: '请先选择酒店再结账。',
      complete_schedule:  '请填写完整日程后再结账。',
      arrival_in_days:    '从下单起约{days}天送达',
      zone_main_island:   '本州中部',
      zone_hokkaido:      '北海道・东北北部',
      zone_kyushu:        '九州',
      zone_okinawa:       '冲绳',
    },

    'zh-TW': {
      search_unavailable: '搜尋暫時無法使用,請稍後再試。',
      no_hotels:          '找不到飯店,請嘗試其他關鍵字。',
      geo_unsupported:    '您的瀏覽器不支援定位功能。',
      locating:           '正在取得位置...',
      location_found:     '您的位置:{lat}, {lng}。請輸入飯店名稱進行搜尋。',
      location_failed:    '無法取得您的位置,請直接輸入飯店名稱。',
      details_failed:     '無法載入飯店資訊,請重試。',
      need_checkin:       '請輸入入住日期。',
      need_checkout:      '請輸入退房日期。',
      need_delivery:      '請選擇您希望的送達日期。',
      checkout_after_in:  '退房日期須晚於入住日期。',
      delivery_before_co: '請選擇退房日前至少1天的送達日 — 退房當天送達可能無法安全簽收。',
      delivery_after_in:  '送達日期須為入住日期當天或之後。',
      earliest_delivery:  '依今日與配送時程計算,最早可送達日期為 {date}。請選擇該日或之後。',
      ok_message:         '禮物將於 <strong>{date}</strong> 送達 — 距您退房還有{days}天。我們將交付前台保管。',
      today_label:        '今天',
      arrives_label:      '送達',
      legend_stay:        '您的住宿期間',
      legend_arrives:     '禮物送達',
      select_hotel_first: '請先選擇飯店再結帳。',
      complete_schedule:  '請填寫完整日程後再結帳。',
      arrival_in_days:    '從下單起約{days}天送達',
      zone_main_island:   '本州中部',
      zone_hokkaido:      '北海道・東北北部',
      zone_kyushu:        '九州',
      zone_okinawa:       '沖繩',
    },

    ko: {
      search_unavailable: '검색이 일시적으로 사용할 수 없습니다. 다시 시도해 주세요.',
      no_hotels:          '호텔을 찾을 수 없습니다. 다른 키워드로 검색해 주세요.',
      geo_unsupported:    '브라우저가 위치 정보를 지원하지 않습니다.',
      locating:           '위치 확인 중...',
      location_found:     '현재 위치: {lat}, {lng}. 호텔 이름을 입력해 검색해 주세요.',
      location_failed:    '위치를 가져올 수 없습니다. 호텔 이름을 직접 입력해 주세요.',
      details_failed:     '호텔 정보를 불러올 수 없습니다. 다시 시도해 주세요.',
      need_checkin:       '체크인 날짜를 입력해 주세요.',
      need_checkout:      '체크아웃 날짜를 입력해 주세요.',
      need_delivery:      '희망 배송일을 선택해 주세요.',
      checkout_after_in:  '체크아웃은 체크인보다 이후 날짜여야 합니다.',
      delivery_before_co: '체크아웃 1일 이상 전을 배송일로 선택해 주세요. 출발 당일 배송은 안전한 수령이 어려울 수 있습니다.',
      delivery_after_in:  '배송일은 체크인 날짜 이후로 설정해 주세요.',
      earliest_delivery:  '오늘과 배송 시간을 고려한 최단 배송일은 {date}입니다. 해당 날짜 이후로 선택해 주세요.',
      ok_message:         '선물은 <strong>{date}</strong> 도착 예정 — 체크아웃 {days}일 전. 프런트에 맡겨 드립니다.',
      today_label:        '오늘',
      arrives_label:      '도착',
      legend_stay:        '숙박 기간',
      legend_arrives:     '선물 도착',
      select_hotel_first: '결제 전에 호텔을 선택해 주세요.',
      complete_schedule:  '결제 전에 일정을 모두 입력해 주세요.',
      arrival_in_days:    '주문 후 약 {days}일 후 도착',
      zone_main_island:   '본섬 중부',
      zone_hokkaido:      '홋카이도・도호쿠 북부',
      zone_kyushu:        '규슈',
      zone_okinawa:       '오키나와',
    },
  };

  // ==========================================================================
  // 配送ゾーンコード → 翻訳キーのマッピング
  // バックエンドの zone-lookup.php が返すゾーンコードに対応
  // ==========================================================================
  const ZONE_CODE_TO_KEY = {
    'main_island':    'zone_main_island',
    'hokkaido':       'zone_hokkaido',
    'tohoku_north':   'zone_hokkaido',
    'kyushu':         'zone_kyushu',
    'okinawa':        'zone_okinawa',
  };

  // ==========================================================================
  // 日付ユーティリティ
  // ==========================================================================
  const JP_HOLIDAYS = new Set([
    '2026-01-01','2026-01-12','2026-02-11','2026-02-23',
    '2026-03-20','2026-04-29','2026-05-03','2026-05-04','2026-05-05','2026-05-06',
    '2026-07-20','2026-08-11','2026-09-21','2026-09-22','2026-09-23',
    '2026-10-12','2026-11-03','2026-11-23',
    '2027-01-01','2027-01-11','2027-02-11','2027-02-23',
    '2027-03-21','2027-03-22','2027-04-29','2027-05-03','2027-05-04','2027-05-05',
    '2027-07-19','2027-08-11','2027-09-20','2027-09-23',
    '2027-10-11','2027-11-03','2027-11-23',
  ]);

  function parseDate(s) {
    if (!s) return null;
    const d = new Date(s + 'T00:00:00');
    return isNaN(d) ? null : d;
  }
  function formatDateISO(d) {
    if (!d) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  function addDays(d, n) {
    const r = new Date(d);
    r.setDate(r.getDate() + n);
    return r;
  }
  function diffDays(a, b) {
    const ms = b.setHours(0,0,0,0) - a.setHours(0,0,0,0);
    return Math.round(ms / 86400000);
  }
  function today() {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }
  function isShippingDay(d) {
    const day = d.getDay();
    if (day === 0 || day === 6) return false;
    return !JP_HOLIDAYS.has(formatDateISO(d));
  }
  function nextShippingDay(d) {
    let r = new Date(d);
    while (!isShippingDay(r)) {
      r = addDays(r, 1);
    }
    return r;
  }
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  function generateSessionToken() {
    return 'wt-' + Math.random().toString(36).slice(2, 16) + '-' + Date.now().toString(36);
  }
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /**
   * Shopify locale → 翻訳辞書のキーへ正規化
   */
  function normalizeLocale(input) {
    const lang = String(input || 'en').toLowerCase();
    if (lang.startsWith('ja')) return 'ja';
    if (lang.startsWith('ko')) return 'ko';
    if (lang.startsWith('zh')) {
      if (lang.includes('tw') || lang.includes('hk') || lang.includes('hant')) return 'zh-TW';
      return 'zh-CN';
    }
    return 'en';
  }

  /**
   * 日付を locale に応じてフォーマット
   * 例: en → "May 18, 2026" / ja → "2026年5月18日" / zh → "2026年5月18日" / ko → "2026년 5월 18일"
   */
  function formatDateLocale(d, locale) {
    if (!d) return '';
    const intlLocale = locale === 'zh-CN' ? 'zh-CN' :
                       locale === 'zh-TW' ? 'zh-TW' :
                       locale;
    try {
      return new Intl.DateTimeFormat(intlLocale, { year: 'numeric', month: 'long', day: 'numeric' }).format(d);
    } catch (e) {
      return formatDateISO(d);
    }
  }

  /**
   * 月 + 年 のラベル（タイムライン用）
   */
  function formatMonthYear(d, locale) {
    try {
      return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long' }).format(d);
    } catch (e) {
      return formatDateISO(d).slice(0, 7);
    }
  }

  /**
   * 短い曜日名（タイムライン用）
   */
  function formatWeekdayShort(d, locale) {
    try {
      return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(d);
    } catch (e) {
      return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()];
    }
  }

  // ==========================================================================
  // PlacesAPI / CartAPI / CheckoutGuard
  // ==========================================================================
  class PlacesAPI {
    constructor(apiBase) { this.apiBase = apiBase.replace(/\/$/, ''); }
    async autocomplete(input, language, sessionToken) {
      const url = `${this.apiBase}/autocomplete.php?input=${encodeURIComponent(input)}&language=${encodeURIComponent(language)}&session_token=${encodeURIComponent(sessionToken)}`;
      const res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error(`Autocomplete failed: ${res.status}`);
      return res.json();
    }
    async placeDetails(placeId, language, sessionToken) {
      const url = `${this.apiBase}/place-details.php?place_id=${encodeURIComponent(placeId)}&language=${encodeURIComponent(language)}&session_token=${encodeURIComponent(sessionToken)}`;
      const res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error(`Place details failed: ${res.status}`);
      return res.json();
    }
    async zoneLookup(lat, lng) {
      const url = `${this.apiBase}/zone-lookup.php?lat=${lat}&lng=${lng}`;
      const res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error(`Zone lookup failed: ${res.status}`);
      return res.json();
    }
    staticMapURL(lat, lng, width = 600, height = 200, zoom = 16) {
      return `${this.apiBase}/static-map.php?lat=${lat}&lng=${lng}&width=${width}&height=${height}&zoom=${zoom}`;
    }
  }

  class CartAPI {
    async get() {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
      return res.json();
    }
    async updateAttributes(attributes) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
      return res.json();
    }
    async clearAllAttributes() {
      return this.updateAttributes({
        'Hotel Name': '', 'Hotel Address': '', 'Hotel Postal Code': '',
        'Hotel Coordinates': '', 'Hotel Place ID': '',
        'Delivery Zone': '', 'Delivery Zone Name': '', 'Delivery Days': '',
        'Check-in Date': '', 'Check-out Date': '', 'Delivery Date': '',
      });
    }
  }

  class CheckoutGuard {
    constructor() {
      this.checkoutSelectors = [
        '[name="checkout"]', '#checkout',
        '.cart__checkout-button', '.cart-checkout-button',
      ];
    }
    findCheckoutButtons() {
      const set = new Set();
      this.checkoutSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => set.add(el));
      });
      return Array.from(set);
    }
    block(message) {
      this.findCheckoutButtons().forEach(btn => {
        btn.setAttribute('data-hotel-checkout-blocked', 'true');
        btn.setAttribute('aria-disabled', 'true');
        if (message) btn.setAttribute('title', message);
      });
      this._submitHandler = (e) => {
        e.preventDefault(); e.stopPropagation();
        const section = document.querySelector('[data-hotel-delivery]');
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      };
      this.findCheckoutButtons().forEach(btn => {
        const form = btn.closest('form');
        if (form && !form.dataset.hotelGuardAttached) {
          form.dataset.hotelGuardAttached = 'true';
          form.addEventListener('submit', this._submitHandler, true);
        }
      });
    }
    allow() {
      this.findCheckoutButtons().forEach(btn => {
        btn.removeAttribute('data-hotel-checkout-blocked');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
        const form = btn.closest('form');
        if (form && form.dataset.hotelGuardAttached && this._submitHandler) {
          form.removeEventListener('submit', this._submitHandler, true);
          delete form.dataset.hotelGuardAttached;
        }
      });
    }
  }

  // ==========================================================================
  // HotelDeliveryController : メインクラス
  // ==========================================================================
  class HotelDeliveryController {
    constructor(root) {
      this.root         = root;
      this.apiBase      = root.dataset.apiBase || 'https://api.withtea.net/api/v1';
      this.locale       = normalizeLocale(root.dataset.language || 'en');
      this.places       = new PlacesAPI(this.apiBase);
      this.cart         = new CartAPI();
      this.guard        = new CheckoutGuard();
      this.sessionToken = generateSessionToken();
      this.selectedHotel = null;
      this.schedule = { checkin: null, checkout: null, delivery: null };

      // 要素参照
      this.elPaneSearch    = root.querySelector('[data-hotel-pane="search"]');
      this.elPaneConfirmed = root.querySelector('[data-hotel-pane="confirmed"]');
      this.elSearch        = root.querySelector('[data-hotel-search]');
      this.elSpinner       = root.querySelector('[data-hotel-spinner]');
      this.elGps           = root.querySelector('[data-hotel-gps]');
      this.elResults       = root.querySelector('[data-hotel-results]');
      this.elHint          = root.querySelector('[data-hotel-hint]');
      this.elError         = root.querySelector('[data-hotel-error]');
      this.elMap           = root.querySelector('[data-hotel-map]');
      this.elName          = root.querySelector('[data-hotel-name]');
      this.elAddress       = root.querySelector('[data-hotel-address]');
      this.elZoneLine      = root.querySelector('[data-hotel-zone-line]');
      this.elZoneText      = root.querySelector('[data-hotel-zone-text]');
      this.elChange        = root.querySelector('[data-hotel-change]');
      this.elCheckin       = root.querySelector('[data-hotel-checkin]');
      this.elCheckout      = root.querySelector('[data-hotel-checkout]');
      this.elDelivery      = root.querySelector('[data-hotel-delivery-date]');
      this.elTimeline      = root.querySelector('[data-hotel-timeline]');
      this.elStatus        = root.querySelector('[data-hotel-status]');

      this.init();
    }

    /**
     * 翻訳ヘルパー
     * t('key') または t('key', {param: value})
     */
    t(key, params) {
      const dict = TRANSLATIONS[this.locale] || TRANSLATIONS.en;
      let str = dict[key] || TRANSLATIONS.en[key] || key;
      if (params) {
        Object.keys(params).forEach(k => {
          str = str.replace(new RegExp('\\{' + k + '\\}', 'g'), params[k]);
        });
      }
      return str;
    }

    // ----------------------------------------------------------------------
    // 初期化
    // ----------------------------------------------------------------------
    async init() {
      const todayStr = formatDateISO(today());
      if (this.elCheckin)  this.elCheckin.min  = todayStr;
      if (this.elCheckout) this.elCheckout.min = todayStr;
      if (this.elDelivery) this.elDelivery.min = todayStr;

      try {
        const cart = await this.cart.get();
        const attrs = cart.attributes || {};
        if (attrs['Hotel Name'] && attrs['Hotel Coordinates']) {
          const [lat, lng] = String(attrs['Hotel Coordinates']).split(',').map(s => parseFloat(s.trim()));
          this.selectedHotel = {
            name:         attrs['Hotel Name'],
            address:      attrs['Hotel Address'],
            postal_code:  attrs['Hotel Postal Code'],
            place_id:     attrs['Hotel Place ID'],
            latitude:     lat,
            longitude:    lng,
            zone:         attrs['Delivery Zone'],
            zone_name_en: attrs['Delivery Zone Name'],
            transit_days: attrs['Delivery Days'],
          };
          if (attrs['Check-in Date'])  this.elCheckin.value  = attrs['Check-in Date'];
          if (attrs['Check-out Date']) this.elCheckout.value = attrs['Check-out Date'];
          if (attrs['Delivery Date'])  this.elDelivery.value = attrs['Delivery Date'];
          this.showConfirmed();
        } else {
          this.showSearch();
          this.guard.block(this.t('select_hotel_first'));
        }
      } catch (err) {
        console.warn('[withTea] Cart init failed:', err);
        this.showSearch();
        this.guard.block(this.t('select_hotel_first'));
      }

      this.elSearch.addEventListener('input', debounce(this.onSearchInput.bind(this), 300));
      this.elSearch.addEventListener('focus', () => {
        if (this.elResults.children.length > 0) this.elResults.hidden = false;
      });
      this.elGps.addEventListener('click', this.onGpsClick.bind(this));
      this.elChange.addEventListener('click', this.onChangeClick.bind(this));

      document.addEventListener('click', (e) => {
        if (!this.elPaneSearch.contains(e.target)) this.elResults.hidden = true;
      });

      if (this.elCheckin)  this.elCheckin.addEventListener('change', () => this.onScheduleChange('checkin'));
      if (this.elCheckout) this.elCheckout.addEventListener('change', () => this.onScheduleChange('checkout'));
      if (this.elDelivery) this.elDelivery.addEventListener('change', () => this.onScheduleChange('delivery'));
    }

    // ----------------------------------------------------------------------
    // 状態遷移
    // ----------------------------------------------------------------------
    showSearch() {
      this.elPaneSearch.hidden    = false;
      this.elPaneConfirmed.hidden = true;
      this.elError.hidden         = true;
    }

    showConfirmed() {
      if (!this.selectedHotel) return;

      this.elName.textContent    = this.selectedHotel.name || '';
      this.elAddress.textContent = this.selectedHotel.address || this.selectedHotel.formatted_address || '';

      const zoneText = this._formatZoneText(this.selectedHotel);
      if (zoneText) {
        this.elZoneText.textContent = zoneText;
        this.elZoneLine.style.display = '';
      } else {
        this.elZoneLine.style.display = 'none';
      }

      const lat = this.selectedHotel.latitude;
      const lng = this.selectedHotel.longitude;
      if (lat != null && lng != null && !isNaN(lat) && !isNaN(lng)) {
        this.elMap.classList.add('is-loading');
        const url = this.places.staticMapURL(lat, lng, 600, 200, 16);
        const img = new Image();
        img.onload = () => {
          this.elMap.style.backgroundImage = `url("${url}")`;
          this.elMap.classList.remove('is-loading');
        };
        img.onerror = () => this.elMap.classList.remove('is-loading');
        img.src = url;
      }

      this.elPaneSearch.hidden    = true;
      this.elPaneConfirmed.hidden = false;
      this.elError.hidden         = true;

      this.initScheduleDefaults();
      this.validateAndRender();
    }

    /**
     * ゾーン名をlocaleに応じて取得
     * 優先順位: ZONE_CODE_TO_KEY経由の翻訳 > zone_name_ja(JAの場合) > zone_name_en
     */
    _getZoneName(h) {
      const zoneCode = (h.zone || '').toLowerCase();
      const translationKey = ZONE_CODE_TO_KEY[zoneCode];
      if (translationKey) {
        const translated = this.t(translationKey);
        if (translated && translated !== translationKey) return translated;
      }
      if (this.locale === 'ja' && h.zone_name_ja) return h.zone_name_ja;
      return h.zone_name_en || zoneCode || '';
    }

    _formatZoneText(h) {
      const days = h.transit_days || h.delivery_days || '';
      const zoneName = this._getZoneName(h);
      if (days && zoneName) {
        return `${zoneName} — ${this.t('arrival_in_days', { days, s: days > 1 ? 's' : '' })}`;
      }
      if (days) {
        return this.t('arrival_in_days', { days, s: days > 1 ? 's' : '' });
      }
      return zoneName;
    }

    // ----------------------------------------------------------------------
    // 検索フロー
    // ----------------------------------------------------------------------
    async onSearchInput(e) {
      const input = e.target.value.trim();
      this.elError.hidden = true;
      if (input.length < 2) {
        this.elResults.innerHTML = '';
        this.elResults.hidden = true;
        return;
      }
      this.elSpinner.hidden = false;
      try {
        // Google Places APIに locale を渡して、その言語の検索結果を取得
        const apiLanguage = this._mapLocaleToApi(this.locale);
        const data = await this.places.autocomplete(input, apiLanguage, this.sessionToken);
        this.renderResults(data.suggestions || []);
      } catch (err) {
        console.error('[withTea] Autocomplete error:', err);
        this.showError(this.t('search_unavailable'));
        this.elResults.hidden = true;
      } finally {
        this.elSpinner.hidden = true;
      }
    }

    /**
     * 翻訳辞書のlocale → Google Places APIの language code
     */
    _mapLocaleToApi(locale) {
      if (locale === 'ja') return 'ja';
      if (locale === 'ko') return 'ko';
      if (locale === 'zh-CN') return 'zh-CN';
      if (locale === 'zh-TW') return 'zh-TW';
      return 'en';
    }

    renderResults(suggestions) {
      this.elResults.innerHTML = '';
      if (suggestions.length === 0) {
        this.elResults.hidden = true;
        this.elHint.textContent = this.t('no_hotels');
        this.elHint.hidden = false;
        return;
      }
      this.elHint.hidden = true;
      this.elResults.hidden = false;

      suggestions.forEach(s => {
        const li = document.createElement('li');
        li.className = 'hotel-delivery__result';
        li.setAttribute('role', 'option');
        li.setAttribute('data-place-id', s.place_id);
        li.tabIndex = 0;
        li.innerHTML = `
          <svg class="hotel-delivery__result-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path d="M3 21V8l9-5 9 5v13M9 21v-7h6v7" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
          </svg>
          <div>
            <div class="hotel-delivery__result-main">${escapeHtml(s.main_text)}</div>
            <div class="hotel-delivery__result-secondary">${escapeHtml(s.secondary_text)}</div>
          </div>
        `;
        li.addEventListener('click', () => this.onResultSelect(s.place_id));
        li.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.onResultSelect(s.place_id);
          }
        });
        this.elResults.appendChild(li);
      });
    }

    // ----------------------------------------------------------------------
    // GPS
    // ----------------------------------------------------------------------
    onGpsClick() {
      if (!navigator.geolocation) {
        this.showError(this.t('geo_unsupported'));
        return;
      }
      this.elGps.disabled = true;
      const originalLabel = this.elGps.querySelector('span').textContent;
      this.elGps.querySelector('span').textContent = this.t('locating');

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.elGps.disabled = false;
          this.elGps.querySelector('span').textContent = originalLabel;
          this.elHint.textContent = this.t('location_found', {
            lat: pos.coords.latitude.toFixed(4),
            lng: pos.coords.longitude.toFixed(4),
          });
          this.elHint.hidden = false;
          this.elSearch.focus();
        },
        () => {
          this.elGps.disabled = false;
          this.elGps.querySelector('span').textContent = originalLabel;
          this.showError(this.t('location_failed'));
        },
        { timeout: 8000 }
      );
    }

    // ----------------------------------------------------------------------
    // ホテル選択
    // ----------------------------------------------------------------------
    async onResultSelect(placeId) {
      this.elResults.hidden = true;
      this.elSpinner.hidden = false;
      this.elError.hidden = true;

      try {
        const apiLanguage = this._mapLocaleToApi(this.locale);
        const details = await this.places.placeDetails(placeId, apiLanguage, this.sessionToken);

        let zoneInfo = {};
        if (!details.zone && !details.delivery && details.latitude && details.longitude) {
          try {
            zoneInfo = await this.places.zoneLookup(details.latitude, details.longitude);
          } catch (e) {
            console.warn('[withTea] Zone lookup failed (non-fatal):', e);
          }
        }

        this.selectedHotel = {
          place_id:     details.place_id || placeId,
          name:         details.name || '',
          address:      details.address || details.formatted_address || '',
          postal_code:  details.postal_code || '',
          prefecture:   details.prefecture || '',
          latitude:     details.latitude,
          longitude:    details.longitude,
          zone:         details.zone || (details.delivery && details.delivery.zone) || zoneInfo.zone || '',
          zone_name_en: details.zone_name_en || (details.delivery && details.delivery.label_en) || zoneInfo.zone_name_en || '',
          zone_name_ja: details.zone_name_ja || (details.delivery && details.delivery.label)    || zoneInfo.zone_name_ja || '',
          transit_days: details.transit_days || (details.delivery && details.delivery.delivery_days) || zoneInfo.transit_days || '',
        };

        await this.saveHotelToCart(this.selectedHotel);
        this.sessionToken = generateSessionToken();
        this.showConfirmed();
      } catch (err) {
        console.error('[withTea] Select error:', err);
        this.showError(this.t('details_failed'));
      } finally {
        this.elSpinner.hidden = true;
      }
    }

    async saveHotelToCart(hotel) {
      const coords = (hotel.latitude != null && hotel.longitude != null)
        ? `${hotel.latitude},${hotel.longitude}` : '';
      return this.cart.updateAttributes({
        'Hotel Name':         hotel.name        || '',
        'Hotel Address':      hotel.address     || '',
        'Hotel Postal Code':  hotel.postal_code || '',
        'Hotel Place ID':     hotel.place_id    || '',
        'Hotel Coordinates':  coords,
        'Delivery Zone':      hotel.zone        || '',
        'Delivery Zone Name': hotel.zone_name_en || '',
        'Delivery Days':      String(hotel.transit_days || ''),
      });
    }

    async onChangeClick() {
      try {
        await this.cart.clearAllAttributes();
      } catch (err) {
        console.warn('[withTea] Clear attributes failed:', err);
      }
      this.selectedHotel = null;
      this.schedule = { checkin: null, checkout: null, delivery: null };
      this.elSearch.value = '';
      if (this.elCheckin)  this.elCheckin.value  = '';
      if (this.elCheckout) this.elCheckout.value = '';
      if (this.elDelivery) this.elDelivery.value = '';
      this.elResults.innerHTML = '';
      this.elResults.hidden = true;
      this.sessionToken = generateSessionToken();
      this.guard.block(this.t('select_hotel_first'));
      this.showSearch();
      this.elSearch.focus();
    }

    // ----------------------------------------------------------------------
    // スケジュール
    // ----------------------------------------------------------------------
    calculateEarliestDelivery() {
      const transit = parseInt(this.selectedHotel && this.selectedHotel.transit_days) || 1;
      const shipDay = nextShippingDay(today());
      return addDays(shipDay, transit);
    }

    initScheduleDefaults() {
      if (!this.selectedHotel) return;
      if (this.elDelivery && !this.elDelivery.value) {
        const checkin = parseDate(this.elCheckin && this.elCheckin.value);
        const earliest = this.calculateEarliestDelivery();
        const suggestion = (checkin && checkin > earliest) ? checkin : earliest;
        this.elDelivery.value = formatDateISO(suggestion);
      }
    }

    onScheduleChange(field) {
      if (field === 'checkin') {
        const checkin = parseDate(this.elCheckin.value);
        if (checkin) {
          this.elCheckout.min = formatDateISO(addDays(checkin, 1));
          this.elDelivery.min = formatDateISO(checkin);
          const delivery = parseDate(this.elDelivery.value);
          if (delivery && delivery < checkin) {
            this.elDelivery.value = formatDateISO(checkin);
          }
        }
      }
      if (field === 'checkout') {
        const checkout = parseDate(this.elCheckout.value);
        if (checkout) {
          this.elDelivery.max = formatDateISO(addDays(checkout, -1));
        }
      }
      this.validateAndRender();
    }

    validateAndRender() {
      const checkin  = parseDate(this.elCheckin && this.elCheckin.value);
      const checkout = parseDate(this.elCheckout && this.elCheckout.value);
      const delivery = parseDate(this.elDelivery && this.elDelivery.value);
      this.schedule = { checkin, checkout, delivery };

      this.renderTimeline(checkin, checkout, delivery);

      const issues = [];
      if (!checkin)  issues.push(this.t('need_checkin'));
      if (!checkout) issues.push(this.t('need_checkout'));
      if (!delivery) issues.push(this.t('need_delivery'));

      if (checkin && checkout && diffDays(new Date(checkin), new Date(checkout)) < 1) {
        issues.push(this.t('checkout_after_in'));
      }
      if (delivery && checkout && diffDays(new Date(delivery), new Date(checkout)) < 1) {
        issues.push(this.t('delivery_before_co'));
      }
      if (delivery && checkin && diffDays(new Date(checkin), new Date(delivery)) < 0) {
        issues.push(this.t('delivery_after_in'));
      }
      if (delivery && this.selectedHotel) {
        const earliest = this.calculateEarliestDelivery();
        if (diffDays(new Date(earliest), new Date(delivery)) < 0) {
          issues.push(this.t('earliest_delivery', { date: formatDateLocale(earliest, this.locale) }));
        }
      }

      const allValid = (issues.length === 0) && this.selectedHotel;

      this.elStatus.hidden = false;
      if (allValid) {
        const bufferDays = diffDays(new Date(delivery), new Date(checkout));
        this.elStatus.className = 'hotel-delivery__status hotel-delivery__status--ok';
        this.elStatus.innerHTML = `
          <svg class="hotel-delivery__status-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="currentColor"/>
            <path d="M7 12l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
          <span>${this.t('ok_message', {
            date: formatDateLocale(delivery, this.locale),
            days: bufferDays,
            s: bufferDays > 1 ? 's' : '',
          })}</span>
        `;
        this.guard.allow();
        this.saveScheduleToCart();
      } else if (this.selectedHotel) {
        this.elStatus.className = 'hotel-delivery__status hotel-delivery__status--error';
        this.elStatus.innerHTML = `
          <svg class="hotel-delivery__status-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="currentColor"/>
            <path d="M12 7v6M12 16v.5" stroke="#fff" stroke-width="2" stroke-linecap="round" fill="none"/>
          </svg>
          <span>${escapeHtml(issues[0])}</span>
        `;
        this.guard.block(issues[0]);
      } else {
        this.elStatus.hidden = true;
      }
    }

    async saveScheduleToCart() {
      if (!this.schedule.checkin || !this.schedule.checkout || !this.schedule.delivery) return;
      try {
        await this.cart.updateAttributes({
          'Check-in Date':  formatDateISO(this.schedule.checkin),
          'Check-out Date': formatDateISO(this.schedule.checkout),
          'Delivery Date':  formatDateISO(this.schedule.delivery),
        });
      } catch (err) {
        console.warn('[withTea] Schedule save failed:', err);
      }
    }

    renderTimeline(checkin, checkout, delivery) {
      if (!this.elTimeline) return;

      const start = today();
      let endRef = addDays(start, 6);
      if (checkout && checkout > endRef) endRef = checkout;
      if (delivery && delivery > endRef) endRef = delivery;

      let totalDays = diffDays(new Date(start), new Date(endRef)) + 1;
      if (totalDays > 14) totalDays = 14;
      if (totalDays < 7) totalDays = 7;

      const cells = [];
      for (let i = 0; i < totalDays; i++) {
        const d = addDays(start, i);
        const dStr = formatDateISO(d);
        const isToday = i === 0;
        const isStay = checkin && checkout && d >= checkin && d <= checkout;
        const isDelivery = delivery && dStr === formatDateISO(delivery);

        let badge = '';
        if (isToday) {
          badge = `<div class="hotel-delivery__timeline-badge hotel-delivery__timeline-badge--today">${this.t('today_label')}</div>`;
        } else if (isDelivery) {
          badge = `<div class="hotel-delivery__timeline-badge hotel-delivery__timeline-badge--delivery">${this.t('arrives_label')}</div>`;
        }

        const classes = ['hotel-delivery__timeline-cell'];
        if (isStay) classes.push('hotel-delivery__timeline-cell--stay');
        if (isToday) classes.push('hotel-delivery__timeline-cell--today');

        cells.push(`
          <div class="${classes.join(' ')}">
            <div class="hotel-delivery__timeline-name">${formatWeekdayShort(d, this.locale)}</div>
            <div class="hotel-delivery__timeline-day">${d.getDate()}</div>
            ${badge}
          </div>
        `);
      }

      const monthLabel = formatMonthYear(start, this.locale);

      this.elTimeline.innerHTML = `
        <div class="hotel-delivery__timeline-month">${monthLabel}</div>
        <div class="hotel-delivery__timeline-grid" style="grid-template-columns: repeat(${totalDays}, minmax(0, 1fr));">
          ${cells.join('')}
        </div>
        <div class="hotel-delivery__timeline-legend">
          <div class="hotel-delivery__timeline-legend-item"><div class="hotel-delivery__timeline-swatch hotel-delivery__timeline-swatch--stay"></div>${this.t('legend_stay')}</div>
          <div class="hotel-delivery__timeline-legend-item"><div class="hotel-delivery__timeline-swatch hotel-delivery__timeline-swatch--delivery"></div>${this.t('legend_arrives')}</div>
        </div>
      `;
      this.elTimeline.hidden = false;
    }

    showError(msg) {
      this.elError.textContent = msg;
      this.elError.hidden = false;
    }
  }

  // ==========================================================================
  // 起動
  // ==========================================================================
  function bootstrap() {
    const roots = document.querySelectorAll('[data-hotel-delivery]');
    roots.forEach(root => {
      if (!root.dataset.hotelDeliveryInitialized) {
        root.dataset.hotelDeliveryInitialized = 'true';
        new HotelDeliveryController(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
